import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordButton} from "../buttons/FilterRecordButton.tsx";
import {AnalyzeRepositoryButton} from '../buttons/AnalyzeRepositoryButton.tsx';
import config from "../config";


const useTools = () => {

    const tools = [
        <AnalyzeRepositoryButton key='analyze'/>,
        <ReloadRecordsButton key='reload'/>,
        <FilterRecordButton key='filter'/>,
    ];

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
